import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import ColorCircle from './ColorCircle';
import { AiOutlineCaretDown } from 'react-icons/ai';
import { Dropdown } from 'react-bootstrap';
import { StyledDropdownButton } from './StyledDropdownButton';
import { colorData } from './_colorData';

function ColorDropDown({ color, setColor }) {
	const labelColors = useSelector((state) => {
		let labelObject = state?.user?.user?.labelInfo?.labels?.visits;
		if (labelObject) {
			return Object.values(labelObject);
		}
		return [];
	});
	const [currColor, setCurrColor] = useState(color);
	const handleColorDropDownChange = (event) => {
		setCurrColor(event);
		if (setColor) {
			setColor(event);
		}
	};
	console.log(labelColors, 'labelColors');
	return (
		<div className="d-flex align-items-center border border-rounded justify-content-center py-2 px-3">
			<ColorCircle color={currColor} />

			<StyledDropdownButton
				id="dropdown-basic-button"
				title={
					<div>
						<AiOutlineCaretDown color="#111" />{' '}
					</div>
				}
				onSelect={handleColorDropDownChange}
			>
				{colorData
					.filter((color) => !labelColors.includes(color))
					.map((color) => (
						<Dropdown.Item href="#" key={color} eventKey={color}>
							<ColorCircle color={color} />
						</Dropdown.Item>
					))}
			</StyledDropdownButton>
		</div>
	);
}

export default ColorDropDown;
